import { Card } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode;
  isActive?: boolean;
  className?: string;
  onClick?: () => void;
}

/**
 * Shared shell for cards displayed in a Carousel: it fills its slide, so every card has the same size.
 */
const CarouselCard = ({ children, isActive = false, className = "", onClick }: Props) => {
  return (
    <Card className={`CarouselCard ${isActive ? "isCarouselCardActive" : ""} ${className}`} onClick={onClick}>
      {children}
    </Card>
  );
};

export default CarouselCard;
